import { Switch } from '@tempo-io/sui-switch';
import { FieldWithStatusIndicator } from '@/features/items/components/item-field-value/FieldWithStatusIndicator';

export const CheckboxField = ({
  name,
  id,
  value,
  isEditable = false,
  onChange,
  isPending,
  isSuccess,
  isError,
  error,
}: {
  id: string;
  name: string;
  value?: boolean;
  isEditable?: boolean;
  onChange?: (value: boolean) => void;
  isPending?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  error?: Error | null;
}) => {
  const inputId = `checkbox-field-${id}`;

  return (
    <FieldWithStatusIndicator
      inputId={inputId}
      name={name}
      isPending={isPending}
      isSuccess={isSuccess}
    >
      <div className="flex flex-col gap-1">
        <Switch
          id={inputId}
          checked={!!value}
          onCheckedChange={onChange}
          disabled={!isEditable || !!isPending}
          data-testid="checkbox-field-switch"
        />
        {isError && error && (
          <span className="text-xs text-text-error" data-testid="checkbox-field-error">
            {error.message}
          </span>
        )}
      </div>
    </FieldWithStatusIndicator>
  );
};
